import PL from './pl/errors.data';
import EN_GB from './uk/errors.data';
import UK from './ua/errors.data';
import DE from './de/errors.data';
import CS from './cs/errors.data';
import RO from './ro/errors.data';
import HU from './hu/errors.data';
import SK from './sk/errors.data';
import BG from './bg/errors.data';
import FR from './fr/errors.data';
import IT from './it/errors.data';
import ES from './es/errors.data';
import NL from './nl/errors.data';
import SV from './sv/errors.data';
import PT from './pt/errors.data';
import DA from './da/errors.data';
import FI from './fi/errors.data';

export default {
    "pl": PL,
    "en-GB": EN_GB,
    "uk": UK,
    "de": DE,
    "cs": CS,
    "ro": RO,
    "hu": HU,
    "sk": SK,
    "bg": BG,
    "fr": FR,
    "it": IT,
    "es": ES,
    "nl": NL,
    "sv": SV,
    "pt": PT,
    "da": DA,
    "fi": FI    
}